export interface XHRLoaderConfig
{
	url: string;
	params?: any;
	userData?: any;
	method?: string;
	async?: boolean;
	cache?: boolean;
	onComplete?: Function;
	json?: boolean;
	onFail?: Function;
}

export class XHRLoader
{
	public static METHOD_POST = "POST";
	public static METHOD_GET  = "GET";

	public static defaultOnFail = function() {};

	public static load(config: XHRLoaderConfig):void
	{

		var defaultConfig:XHRLoaderConfig =
		{
			url: "",
			method: XHRLoader.METHOD_POST,
			async: true,
			cache: true,
			json: true,
			onFail: XHRLoader.defaultOnFail
		};

		for (var key in config) {
			defaultConfig[key] = config[key];
		}

		var xhr = new XMLHttpRequest();

		var url = defaultConfig.url;

		if (defaultConfig.cache)
		{
			if (!defaultConfig.params)
			{
				defaultConfig.params = {};
			}
			defaultConfig.params["noCache"] = new Date().getTime();
		}

		if (defaultConfig.params && defaultConfig.method === XHRLoader.METHOD_GET)
		{
			url += "?" + XHRLoader.encodeParams(defaultConfig.params);
		}

		xhr.open(defaultConfig.method, url, defaultConfig.async);

		xhr.onload = function(event:Event)
		{
			if (xhr.status === 200)
			{
				if (defaultConfig.onComplete)
				{
					var response = xhr.responseText;
					if (defaultConfig.json)
					{
						try
						{
							response = JSON.parse(response);
						}
						catch(e)
						{
							defaultConfig.onFail(xhr, event, defaultConfig);
							return;
						}
					}
					defaultConfig.onComplete(xhr, response, config, true);
				}
			}
			else
			{
				defaultConfig.onFail(xhr, event, defaultConfig);
			}
		};

		xhr.onerror = xhr.ontimeout = xhr.onabort = function(event:Event)
		{
			defaultConfig.onFail(xhr, event, defaultConfig);
		};

		if (defaultConfig.method === XHRLoader.METHOD_POST)
		{
			var encoded_params = XHRLoader.encodeParams(config.params);

			xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
			//xhr.setRequestHeader("Content-length", <string><any>encoded_params.length);

			xhr.send(encoded_params);
		}
		else
		{
			xhr.send();
		}
	}

	public static encodeParams(params:any):string
	{
		var str:string[] = [];

		for (var key in params)
		{
			str.push(encodeURIComponent(key) + "=" + encodeURIComponent(params[key]));
		}
		return str.join("&");
	}
}